/**
 * Returns a count + pluralized label.
 * e.g. pluralize(1, 'member') → "1 member"
 *      pluralize(5, 'member') → "5 members"
 *      pluralize(2, 'person', 'people') → "2 people"
 */
export function pluralize(count: number, singular: string, plural?: string): string {
    return `${count} ${count === 1 ? singular : (plural ?? singular + 's')}`;
}
